import React, { useRef } from 'react';
import {
  getTranslatedText,
  TEXT_LENGTH,
  Editor,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { TextField } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import { CustomFormTemplate } from '@nile/mangifera/src/Containers/FormContainers';
import { noop } from 'lodash';
import envConfig from '@nile/home/src/Config/env';
import SuperEditor from '@nile/components/src/Components/RichTextEditor/SuperEditor';

function TicketForm(props) {
  const {
    selectedFormTemplate: selectedFormTemplateTemp = {},
    ticket = {},
    updateField = noop,
    errors = {},
    template = {},
    updateTemplate = noop,
    handleFileAttachments = noop,
    handleAttachmentsDeletion = noop,
    updateSelectedFormTemplate = noop,
    mandatoryFieldsOnCreation = noop,
    setMandatoryFieldsOnCreation = noop,
    isSuperEditor = false,
    editorConfig = {}
  } = props;

  /** temp fix to remove the ticket type, once backend migration is completed revert this code
   * TODO: TEMP FIX
   * 1. change the props variable name back to 'selectedFormTemplate' and remove the below code
   */
  function removeTicketType() {
    const fieldDetails = selectedFormTemplateTemp?.fieldDetails
      ? JSON.parse(selectedFormTemplateTemp?.fieldDetails)
      : {};
    if (fieldDetails?.layout) {
      fieldDetails.layout = fieldDetails.layout.filter(
        (l) => l?.field?.fieldProps?.id !== 'ticketType'
      );
      return {
        ...selectedFormTemplateTemp,
        fieldDetails: JSON.stringify(fieldDetails)
      };
    }
    return selectedFormTemplateTemp;
  }
  const selectedFormTemplate = removeTicketType();
  /** Temp fix ends here */
  const intl = useIntl();
  const editorRef = useRef();
  const clientId = ticket?.client?.accountId;
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  return (
    <div>
      <div className="pl20 pr20">
        <div className="ta-l pl20 pr30 g10 fx actr">
          <div className="w100">
            <TextField
              id="ticketSubject"
              value={ticket?.subject}
              onChange={(val) => {
                updateField('subject', val);
              }}
              placeholder={getTranslatedText(intl, 'ticket.new.pl.subject')}
              type="text"
              customClassName="Header-Input"
              error={errors?.subject?.[0]}
              maxLength={TEXT_LENGTH.size_5}
              fontSize="fontLarge"
              noborder
            />
          </div>
        </div>
        <div className="editor-holder p15 mt20">
          {isSuperEditor ? (
            <SuperEditor
              key={clientId}
              title="Add Attachments"
              description="Upload/drop files here"
              allowMultiple
              toolbarSticky={false}
              config={{
                htmlUntouched: true
              }}
              allowMentions
              storeConfig={editorConfig}
              placeholder={getTranslatedText(intl, 'ticket.new.pl.desc')}
              module="TICKET" // To attach inline images
              details={
                clientId
                  ? {
                      operation: 'CREATE',
                      clientId: clientId
                    }
                  : { operation: 'CREATE' }
              }
              uploadParams={{
                module: 'TICKET_CONVERSATION_ATTACHMENT'
              }} // To upload attachment
              attachmentUploadUrl={`${envConfig.fileRoot}/upload`} // To upload attachment
              disableImageUpload={isMSPProduct && !clientId}
              disableAttachment={isMSPProduct && !clientId}
            />
          ) : (
            <Editor
              key={!!clientId}
              editorRef={editorRef}
              template={template}
              updateTemplate={updateTemplate}
              module="TICKET"
              placeholder={getTranslatedText(intl, 'ticket.new.pl.desc')}
              details={
                clientId
                  ? {
                      operation: 'CREATE',
                      clientId: clientId
                    }
                  : { operation: 'CREATE' }
              }
              handleFileAttachments={handleFileAttachments}
              handleAttachmentsDeletion={handleAttachmentsDeletion}
              title="Add Attachments"
              description="Upload/drop files here"
              allowMultiple
              toolbarSticky={false}
              disableImageUpload={isMSPProduct && !clientId}
              disableAttachment={isMSPProduct && !clientId}
            />
          )}
        </div>
      </div>
      {selectedFormTemplate ? (
        <div
          className={
            !selectedFormTemplate ? '' : 'custom-form-layout-card ml-5'
          }
        >
          <CustomFormTemplate
            ticket={ticket}
            selectedFormTemplate={selectedFormTemplate}
            updateField={updateField}
            updateSelectedFormTemplate={updateSelectedFormTemplate}
            contentHeight
            mandatoryFieldsOnCreation={mandatoryFieldsOnCreation}
            setMandatoryFieldsOnCreation={setMandatoryFieldsOnCreation}
            errors={errors}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

export default TicketForm;
